// Third party
import axios from 'axios';

// Components
import { DEV_APP_API_URL } from '../constants';
import { TForgotPasswordReq, TLoginReq, TRegisterReq } from '../types/requests';

export function WelcomeController() {
  const login = async <T> (data: TLoginReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/auth/token`, data);
  };

  const forgotPassword = async <T>(data: TForgotPasswordReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/auth/forgot-password`, data);
  };

  const register = async <T>(data: TRegisterReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/user/register`, data);
  };

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
  };

  return { login, forgotPassword, register, logout };
}
